import { docodeHexResponse } from '../../../_common/common.utils';
import GroupWiseLoanProposalActionTypes from './group-wise-loan-proposal.types';

const INITIAL_STATE = {
	addGroupWiseLoanProposalResponse: null,
	updateGroupWiseLoanProposalResponse: null,
};

const groupWiseLoanProposalReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START ADD GROUP WISE LOAN PROPOSAL  ******************** */
		case GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addGroupWiseLoanProposalResponse: action.payload };

		case GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_FAILURE:
			return { ...state, addGroupWiseLoanProposalResponse: action.payload };

		case GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addGroupWiseLoanProposalResponse: null };
		/** *********************  END ADD GROUP WISE LOAN PROPOSAL  ******************** */

		/** *********************  START UPDATE GROUP WISE LOAN PROPOSAL  ******************** */
		case GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateGroupWiseLoanProposalResponse: action.payload };

		case GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateGroupWiseLoanProposalResponse: action.payload };

		case GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateGroupWiseLoanProposalResponse: null };

		/** *********************  END UPDATE GROUP WISE LOAN PROPOSAL  ******************** */

		case GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_SUCCESS:
			return {
				...state,
				getSubGrouplistResponse: action.payload,
				getSubGrouplistResponseArr: docodeHexResponse(
					action.payload,
					'GetSubGroupDetailsTokenKey',
				),
			};

		case GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_FAILURE:
			return { ...state, getSubGrouplistResponse: action.payload };

		case GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_RESPONSE_CHANGED:
			return { ...state, getSubGrouplistResponse: null };

		default:
			return state;
	}
};
export default groupWiseLoanProposalReducer;
